module.exports = __webpack_public_path__ + "static/media/6@960w.801be06a.jpg";